module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#calendar",
      toString: function () {
        return this.url;
      }
    }